/* eslint-disable @typescript-eslint/no-unused-vars */
import { LitElement } from 'lit';
import { NotImplementedError } from '../notImplementedError.js';
import { GlobalRxStores } from './globalRxStores.js';
export class RxElement extends LitElement {
    constructor() {
        super(...arguments);
        this._subscriptionsInitalized = true;
    }
    // /**
    //  *
    //  */
    //   constructor() {
    //     super();
    //   }
    subscribeField(fieldName, behaviorSubjectKey) {
        const subjectKey = behaviorSubjectKey !== null && behaviorSubjectKey !== void 0 ? behaviorSubjectKey : fieldName;
        const subject = GlobalRxStores.getBehaviorSubject(subjectKey);
        const rxElement = this;
        const subscription = subject.subscribe((val) => {
            rxElement[fieldName] = val;
        });
        rxElement.trackSubscription(subscription);
    }
    trackSubscription(subscription) {
        var _a;
        (_a = this._trackedSubscriptions) !== null && _a !== void 0 ? _a : (this._trackedSubscriptions = []);
        this._trackedSubscriptions.push(subscription);
    }
    _unsubscribeFromTrackedSubscriptions() {
        if (this._trackedSubscriptions) {
            this._trackedSubscriptions.forEach(subscription => {
                if (subscription) {
                    subscription.unsubscribe();
                }
            });
            this._trackedSubscriptions.length = 0;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        // Generally the constructor through initializers has created the subscriptions,
        // however if the component was disconnected and then reconnected, we need to reinitialize
        // TODO enable reinitialization
        if (!this._subscriptionsInitalized) {
            throw new NotImplementedError('ReactiveRxElement with Subscriptions does not yet support reconnecting');
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this._trackedSubscriptions && this._trackedSubscriptions.length > 0) {
            this._unsubscribeFromTrackedSubscriptions();
            this._subscriptionsInitalized = false;
        }
    }
}
//# sourceMappingURL=rxElement.js.map